import React from "react";

function Download() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M19 9h-4V3H9v6H5l7 8zM4 19h16v2H4z"/></svg>
  );
}

export default Download;
